import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PrimeReactProvider } from "primereact/api";

import "./styles/layers.css";
import "./styles/tokens.colors.css";
import "./styles/tokens.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
// O tema prime-react tem de vir antes dos módulos dos componentes (carregados por `@/shared` e `App`): as variantes
// por `[data-*]` (inline-message etc.) usam `:where()` e dependem da ordem no bundle.
import "./styles/prime-react/index.scss";
import "./styles/globals.css";
import "./styles/scrollbar.scss";

import { PRIME_LOCALE } from "@/ds/locale/prime-locale";
import { initializeDependencies } from "@/shared";
import App from "./App";

initializeDependencies();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PrimeReactProvider value={{ ripple: true, locale: PRIME_LOCALE }}>
      <App />
    </PrimeReactProvider>
  </StrictMode>,
);
